<template>
  <main class="history">
    <img class="close_icon" src="@/assets/close.svg" v-on:click="back()" />
    <div class="history_contents">

      <div class="history_contents__main">
        <div class="history_header">
          <div class="history_header__title">
            診断への回答
          </div>
          <div class="history_header__description">以下の通り回答しています</div>

          <div class="history_header__progress" v-if="false">
            <div class="history_header__progress_bar">
              <div style="position: relative; height: 12px">
                <progress style="position: absolute; top: 0;" :value="10" max="100"></progress>
              </div>

            </div>
          </div>
        </div>
        <div class="history_body">
          <div class="">
            <div v-if="page.isProgress == false">

              <template v-for="(item, index) in page.qa?.getHistory()" :key="index">

                <h2 class="qamultibtn" v-if="index == 0">
                  <div class="qa__question">
                    <div class="qa__question_icon">Q{{ item.getStep() }}</div>
                    <div class="qa__question_title" v-if="item.getPhase() == 'entry'">
                      最もやりたいことを教えてください
                    </div>
                    <div class="qa__question_title" v-if="item.getPhase() != 'entry'">
                      {{ item.getTitle() }}
                    </div>
                  </div>
                  <div class="qa__answer">
                    <div class="qa__answer_icon">A{{ item.getStep() }}</div>
                    <div class="qa__answer_title">
                      {{ makeAnswerStringByHistory(item) }}
                      <div v-if="makeAnswerStringByHistory(item).length == 0">スキップ</div>
                    </div>
                  </div>
                </h2>


                <h2 class="qamultibtn" v-if="index != 0" v-on:click="page.select(item.getId())"
                :class="[
                    page.selectId == item.getId() ? 'qamultibtn--selected' : '',
                  ]"
                
                >
                  <div class="qa__question">
                    <div class="qa__question_icon"
                    :class="[page.selectId == item.getId() ? 'qa__question_icon--active' : '']">Q{{ item.getStep() }}</div>
                    <div class="qa__question_title" v-if="item.getPhase() == 'entry'">
                      「{{ item.getTitle() }}」で他にやりたいことは？
                    </div>
                    <div class="qa__question_title" v-if="item.getPhase() != 'entry'">
                      {{ item.getTitle() }}
                    </div>
                  </div>
                  <div class="qa__answer">
                    <div class="qa__answer_icon"
                    :class="[page.selectId == item.getId() ? 'qa__answer_icon--active' : '']">A</div>
                    <div class="qa__answer_title">
                      {{ makeAnswerStringByHistory(item) }}
                      <div v-if="makeAnswerStringByHistory(item).length == 0">スキップ</div>
                    </div>
                  </div>
                </h2>
              </template>

            </div>
          </div>
        </div>
        <div class="history_control">
          <div class="history_control__description">
            選択した項目から内容の変更・再診断ができます
          </div>
          <button class="history_control__next btn_primary" :class="[page.selectId == null ? 'btn_primary--disabled' : '']" v-on:click="gotHistory()">
            再診断
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.qa__answer_title {
  margin-top: 4px;
}

</style>

<style scoped>
.history_header {
  margin-top: 48px;
  padding: 16px;
}

.history_body {
  padding: 16px;
}

.history_control {
  padding: 16px;
  display: flex;
}

.history_header__title {
  font-size: 20px;
  font-weight: bold;
  line-height: 150%;
  color: #00ADA9;
}

.history_header__description {
  font-size: 14px;
  line-height: 142%;
  color: #636464;
}

.history_contents__main {
  max-width: 640px;
  margin: auto;
}

.history_control__next {
  margin-left: auto;
  width: 186px;
}
</style>


<style scoped>
progress {
  width: 100%;
  height: 6px;
  border-radius: 2px;
}

progress::-webkit-progress-bar {
  background-color: #e2e3e3;
  border-radius: 15px;
}

progress::-webkit-progress-value {
  background: rgb(255, 107, 74);
  border-radius: 15px;
}

progress::-moz-progress-bar {
  border-radius: 15px;
  background-color: #e2e3e3;
}

progress::-ms-fill {
  background: rgb(255, 107, 74);
  border-radius: 15px;
}
</style>
<style scoped>
.qamultibtn {
  background: #f9fbfb;
  color: #444545;
  padding: 4px;
  border: 2px solid #e2e3e3;
  border-radius: 4px;
  font-size: 14px;
  line-height: 142%;
  font-weight: bold;
  margin-top: 8px;
  cursor: pointer;
}

.qamultibtn--first {
  margin-top: 0px;
}

.qamultibtn:hover {
  border: 2px solid #00c9c9;
}

.qamultibtn--selected {
  background: #fff;
  border: 2px solid #00aeaa;
}

.qamultibtn__description {
  font-weight: 400;
  font-size: 12px;
  line-height: 126%;
  margin-top: 2px;
  color: #636464;
}

.qasinglebtn__description {
  font-weight: 400;
  font-size: 12px;
  line-height: 126%;
  margin-top: 2px;
  color: #636464;
}

.history_header__progress_bar {
  margin-top: 12px;
}

.history_control__description {
  font-size: 14px;
  font-weight: 400;
  color: #444444;
}

.qa__question_icon {
  width: 25px;
  text-align: center;
}
.qa__answer_icon {
  width: 25px;
  text-align: center;
}

</style>
<script>
// @ is an alias to /src

import tacklebox from "tacklebox";

import { HistoryPage } from "@/js/page/HistoryPage.js";

tacklebox.d("xx");

export default {
  name: "HistoryPage",
  data() {
    return {
      testdata: "kani",
      page: new HistoryPage(),
    };
  },
  mounted() {
    this.page.interviewId = this.$route.params.id;
    this.pager.changePage(this.page);
    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";
  },
  beforeMount() {
    //
  },
  methods: {
    gotHistory() {
      let hs = this.page.qa.getHistory();
      for (let i in hs) {
        let h = hs[i];
        if (h.getId() == this.page.selectId) {
          console.log(h);
          console.log(h.getPhase());
          if (h.getPhase() == "entry") {
            if (window.confirm("回答履歴は消えます")) {
              this.entrydelete(h.getId());
            }
          }else{
            this.qadelete(h.getId());
          }
        }
      }
    },
    entrydelete(id) {
      const self = this;
      console.log(id);
      fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.page.interviewId + "/histories/" + id, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(rbody)
      })
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          self.$router.push({
            name: "expectation",
            params: { id: self.page.interviewId },
          });
        })
        .catch((error) => {
          tacklebox.e(error)
        });
    },
    qadelete(id) {
      // const self = this;
      console.log(id);
      fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.page.interviewId + "/histories/" + id, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(rbody)
      })
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          // self.page.loadQa();
          location.href = process.env.VUE_APP_SELF + "/#/qa/question/"+this.page.interviewId
          return;
          
        })
        .catch((error) => {
          tacklebox.e(error)
        });

    },

    getFirstAnswer() {
      let hs = this.page.qa?.getHistory();
      if (hs) {
        if (hs.length > 0) {
          //
          let res = "";
          let csv = "";
          let ts = hs[0].getReplyTitles();
          for (let i in ts) {
            res += csv + ts[i];
            csv = "／";
          }

          return res;
        }
      }
      return "";
    },
    makeAnswerStringByHistory(history) {
      let res = "";
      let csv = "";
      let ts = history.getReplyTitles();
      for (let i in ts) {
        res += csv + ts[i];
        csv = "／";
      }

      return res;
    },
    gotoHistory() {
      this.$router.push({ name: "history" });
    },
    back() {
      this.$router.push({ name: "report" });
    },
  },
  components: {},
  props: {
    pager: Object,
  },
};
</script>
